import React from 'react'
import { ReactComponent as LeftOlive } from 'components/ContentBox/img/left_olive.svg'
import { ReactComponent as RightOlive } from 'components/ContentBox/img/right_olive.svg'
import styles from './RowScore.module.scss'
import { observer } from 'mobx-react'

function RowScore({
  correctAnswers = 0,
  percentage = 0,
  withoutScores = false,
}) {
  return (
    <div className={styles.mainTableRowScore}>
      <LeftOlive />
      <div className={styles.bigNumbers}>
        {!withoutScores && (
          <div className={styles.largeNumber}>{correctAnswers}</div>
        )}
        <div
          className={
            withoutScores
              ? `${styles.secondaryNumber} ${styles.redLargePercentage}`
              : styles.secondaryNumber
          }
        >
          {`${percentage}%`}
        </div>
      </div>
      <RightOlive />
    </div>
  )
}

export default observer(RowScore)
